module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "recordOrderMod",
    on: {
      "click": _vm.actionFn
    }
  }, [_c('div', {
    staticClass: "ListItem"
  }, [_c('div', {
    staticClass: "itemContent"
  }, [_c('div', {
    staticClass: "item-row"
  }, [_c('div', {
    staticClass: "itemTime"
  }, [_vm._v("酒后代驾")]), _vm._v(" "), _c('div', {
    staticClass: "itemStatus"
  }, [(_vm.status.status !== 40) ? _c('i', {
    staticClass: "iconfont icon-jiantou"
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "text",
    class: _vm.status.name === '新单' ? 'textRed' : _vm.status.name === 5 || _vm.status.name === 6 ? 'textAsh' : ''
  }, [_vm._v("\n                " + _vm._s(_vm.status.name) + "\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "item-time"
  }, [_c('i', {
    staticClass: "iconfont icon-shijian1"
  }), _vm._v(" "), _c('span', {
    staticClass: "site"
  }, [_vm._v(_vm._s(_vm.serverTime))])]), _vm._v(" "), _c('div', {
    staticClass: "item-address"
  }, [_c('i', {
    staticClass: "yuan"
  }), _vm._v(" "), _c('span', {
    staticClass: "site"
  }, [_vm._v(_vm._s(_vm.startAddress))])]), _vm._v(" "), _c('div', {
    staticClass: "item-address"
  }, [_c('i', {
    staticClass: "yuan color-red"
  }), _vm._v(" "), _c('span', {
    staticClass: "site"
  }, [_vm._v(_vm._s(_vm.endAddress))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a0220cc2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/module/recordOrderMod/src/recordOrderMod.vue
// module id = 559
// module chunks = 0